import AdminGuard from '@/auth/guard/admin-guard';
import { UsMktListPage, UsMktEditPage, UsMktCreatePage } from './imports';

export const usMktRoutes = [
  {
    path: 'us-mkt',
    children: [
      {
        element: (
          <AdminGuard hasContent>
            <UsMktListPage />
          </AdminGuard>
        ),
        index: true,
      },
      {
        path: 'list',
        element: (
          <AdminGuard hasContent>
            <UsMktListPage />
          </AdminGuard>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <AdminGuard hasContent>
            <UsMktEditPage />
          </AdminGuard>
        ),
      },
      {
        path: 'new',
        element: (
          <AdminGuard hasContent>
            <UsMktCreatePage />
          </AdminGuard>
        ),
      },
    ],
  },
];
